import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';

interface IWaitingAudioOpponentsToastPresenter {
  call: Call;
  isToastShown: boolean;
  canStartAudio: boolean;
  onPlayAudioClick(): void;
}

export const useWaitingAudioOpponentsToastPresenter = (): IWaitingAudioOpponentsToastPresenter => {
  const context = useCallContext();

  const presenter = useLocalObservable<IWaitingAudioOpponentsToastPresenter>(() => ({
    get call(): Call {
      return context.call;
    },

    get isToastShown(): boolean {
      return presenter.call.viewState.isWaitingAudioShow;
    },

    get canStartAudio(): boolean {
      return presenter.call.viewState.isWaitingAudioButtonShow;
    },

    onPlayAudioClick(): void {
      context.callController.playOpponentsAudio();
      presenter.call.viewState.setIsWaitingAudioShow(false);
    },
  }));

  return presenter;
};
